import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  background: var(--neutral-50);
  border-bottom: 1px solid var(--neutral-200);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.95);
`;

const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
`;

const Logo = styled(Link)`
  font-size: var(--text-2xl);
  font-weight: 700;
  font-family: var(--font-serif);
  color: var(--primary-800);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  
  &:hover {
    color: var(--primary-900);
    text-decoration: none;
  }

  @media (max-width: 768px) {
    font-size: var(--text-xl);
  }
`;

const LogoIcon = styled.span`
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-800) 100%);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: var(--text-lg);
  font-weight: bold;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: var(--space-8);

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(Link)`
  font-size: var(--text-base);
  color: var(--neutral-700);
  font-weight: 500;
  transition: color var(--transition-fast);
  position: relative;

  &:hover {
    color: var(--primary-700);
    text-decoration: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: var(--primary-600);
    transition: width var(--transition-base);
  }

  &:hover::after {
    width: 100%;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: var(--text-2xl);
  color: var(--neutral-700);
  cursor: pointer;
  padding: var(--space-2);

  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileMenu = styled.div`
  position: fixed;
  top: 72px;
  left: 0;
  right: 0;
  background: white;
  border-bottom: 1px solid var(--neutral-200);
  box-shadow: var(--shadow-lg);
  padding: var(--space-4);
  display: ${props => props.$isOpen ? 'block' : 'none'};
  animation: ${props => props.$isOpen ? 'slideDown 0.3s ease' : 'none'};

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const MobileNavLink = styled(Link)`
  display: block;
  padding: var(--space-3) 0;
  color: var(--neutral-700);
  font-weight: 500;
  border-bottom: 1px solid var(--neutral-100);

  &:hover {
    color: var(--primary-700);
    text-decoration: none;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo to="/" onClick={closeMobileMenu}>
          <LogoIcon>I</LogoIcon>
          Intellica
        </Logo>

        <Nav>
          <NavLink to="/">Articles</NavLink>
          <NavLink to="/about">About</NavLink>
        </Nav>

        <MobileMenuButton onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? '✕' : '☰'}
        </MobileMenuButton>
      </HeaderContent>

      <MobileMenu $isOpen={isMobileMenuOpen}>
        <MobileNavLink to="/" onClick={closeMobileMenu}>Articles</MobileNavLink>
        <MobileNavLink to="/about" onClick={closeMobileMenu}>About</MobileNavLink>
      </MobileMenu>
    </HeaderContainer>
  );
};

export default Header;